<template>
  <body id="poster">
    <div class="login-wrapper">
      <!-- Logo 部分 -->
      <div class="logo-container">
        <img src="/favicon.ico" alt="捏词Family Logo" class="logo" />
      </div>

      <!-- 登录表单 -->
      <el-form
        :model="loginForm"
        class="login-container"
        ref="loginform"
        :rules="rules"
        lable-position="left"
        label-width="0px"
      >
        <h3 class="login-title">捏词Family</h3>
        <el-form-item prop="adminId">
          <el-input
            v-model="loginForm.adminId"
            autocomplete="off"
            placeholder="账号(Id)"
            :trim="true"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            show-password
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
            placeholder="密码"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-button-item">
          <el-button
            type="primary"
            class="login-button"
            size="large"
            style="background: #000; border: none"
            @click="onSubmit(loginForm)"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 版权声明 -->
    <div class="copyright">© 捏词</div>
  </body>
</template>
<script>
import { admin } from "../../../api/index";

export default {
  data() {
    return {
      loginForm: {
        adminId: "",
        password: "",
      },
      rules: {
        adminId: [
          {
            required: true,
            pattern: "[^ \x22]+",
            message: "请输入账号",
            trigger: "blur",
          },
          { min: 4, max: 12, message: "用户名长度为4-12位", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            pattern: "[^ \x22]+",
            message: "请输入密码",
            trigger: "blur",
          },
          { min: 6, max: 12, message: "密码长度在6-12位之间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    register() {},

    onSubmit(data) {
      this.$refs.loginform.validate((valid) => {
        if (valid) {
          // 表单校验通过，可以执行提交逻辑
          // ...
          admin.login(data).then((res) => {
            if (res.code == 200) {
              // 存储token
              localStorage.setItem("m-token", res.data.token);
              // 存储用户信息
              localStorage.setItem(
                "userInfo",
                JSON.stringify({
                  adminId: res.data.adminId,
                  adminName: res.data.adminName,
                  adminType: res.data.adminType,
                })
              );
              this.$router.push({ name: "adminTable" });
            } else {
              this.$message.error("账号或密码错误，请您再检查一下");
            }
          });
        } else {
          // 表单校验不通过，不执行提交逻辑
          return false;
        }
      });
    },
    getUserInfo() {
      localStorage.getItem("userInfo");
    },
  },
};
</script>

<style>
#poster {
  background: white;
  background-position: center;
  height: 100vh; /* 使用视口高度 */
  width: 100%;
  background-size: cover;
  position: fixed;
  display: flex; /* 使用弹性布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

body {
  margin: 0px;
  padding: 0px;
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px; /* logo和登录框之间的间距 */
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  width: 80px;
  height: 80px;
  border-radius: 50%; /* 圆形logo */
  background: white;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.1); /* 鼠标悬停时放大效果 */
}

.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  width: 400px; /* 增大登录框宽度 */
  padding: 40px 40px 20px 40px; /* 增大内边距 */
  background: #fff;
  border: 1px solid #eaeaee;
  box-shadow: 0 0 25px #cac6c6;
}

.login-title {
  text-align: center;
  margin-bottom: 30px; /* 增大标题下方间距 */
  color: #333;
  font-size: 26px; /* 增大标题字体 */
  font-weight: 600;
}

.login-button-item {
  text-align: center;
  margin-top: 25px; /* 增大按钮上方间距 */
}

.login-button {
  width: 100%;
  height: 48px; /* 增大按钮高度 */
  padding: 14px; /* 增大按钮内边距 */
  font-size: 18px; /* 增大按钮字体 */
  font-weight: 600;
  border-radius: 8px;
}

/* 自定义输入框样式 */
.el-input {
  margin-bottom: 20px; /* 增大输入框间距 */
}

.el-input__inner {
  height: 48px !important; /* 增大输入框高度 */
  font-size: 16px !important; /* 增大输入框字体 */
  padding: 0 15px 0 12px !important; /* 调整内边距：上 右 下 左 */
}

/* Element Plus large size 增强 */
.el-input--large .el-input__inner {
  height: 50px !important;
  font-size: 16px !important;
  padding: 0 15px 0 12px !important; /* 调整内边距：左边12px，右边15px */
}

.el-form-item {
  margin-bottom: 25px; /* 增大表单项间距 */
}

/* 版权声明样式 */
.copyright {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #999;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  z-index: 100;
}
</style>
